import { get, isDate } from 'lodash';
import { MONAT_LISTE } from '../../../../lib/constants/constant';
import { FormulasResultType } from '../../../../lib/types/types';

// import schemas
import AntragSchema from '../../../../lib/paths/antrag_FULL_Paths.json';
import KostenPositionSchema from '../../../../lib/paths/kostenposition_FULL_Paths.json';
const P = AntragSchema.attributes;
const KP_P = KostenPositionSchema.attributes;

export const calculateProjektStartJahr = (application: any, vonTag: number, vonMonat: string): FormulasResultType[] => {
	const result: FormulasResultType[] = [];
	const projektStartDatum = new Date(get(application, P.Allgemein_Geplante_Projektlaufzeit_von.path, ''));

	if (!projektStartDatum || !isDate(projektStartDatum)) {
		return result;
	}

	const startYear = projektStartDatum.getFullYear();
	const vonMonatIndex = getMonthIndex(vonMonat);

	if (vonMonatIndex === -1) {
		throw new Error('Invalid month name');
	}

	// Stichtag im Jahr des Projektstarts
	const stichtagImStartjahr = new Date(startYear, vonMonatIndex, vonTag);

	let startJahr;

	// Wenn Projektstart VOR dem Stichtag liegt → Kalenderjahr des Projektstarts
	if (projektStartDatum < stichtagImStartjahr) {
		startJahr = startYear;
	}
	// Wenn Projektstart AM ODER NACH dem Stichtag liegt
	else {
		// Wenn Stichtag im ersten Halbjahr (Jan-Jun) → gleiches Kalenderjahr
		if (vonMonatIndex < 6) {
			startJahr = startYear;
		}
		// Wenn Stichtag im zweiten Halbjahr (Jul-Dez) → nächstes Kalenderjahr
		else {
			startJahr = startYear + 1;
		}
	}

	result.push({
		path: P.Allgemein_Projektstart_Jahr.path,
		value: startJahr,
	});
	return result;
};

export const calculateProjektDauer = (
	application: any,
	vonTag: number,
	vonMonat: string,
	_bisTag: number,
	_bisMonat: string
): FormulasResultType[] => {
	const result: FormulasResultType[] = [];
	const projektStartVon = get(application, P.Allgemein_Geplante_Projektlaufzeit_von.path, '');
	const projektStartBis = get(application, P.Allgemein_Geplante_Projektlaufzeit_bis.path, '');

	if (!projektStartVon || !projektStartBis) {
		return result;
	}

	const startDate = new Date(projektStartVon);
	const endDate = new Date(projektStartBis);

	if (!isDate(startDate) || !isDate(endDate)) {
		return result;
	}

	const vonMonatIndex = getMonthIndex(vonMonat);
	if (vonMonatIndex === -1) {
		throw new Error('Invalid month name');
	}

	// Hilfsfunktion: Erstellt Geschäftsjahr-Stichtag für ein gegebenes Jahr
	const createStichtag = (year: number): Date => {
		return new Date(year, vonMonatIndex, vonTag);
	};

	// Finde das erste Geschäftsjahr, das vom Projekt berührt wird
	let currentYear = startDate.getFullYear();
	let currentStichtag = createStichtag(currentYear);

	// Falls Projektstart nach dem Stichtag liegt, gehe zum nächsten Stichtag
	if (startDate >= currentStichtag) {
		currentYear++;
		currentStichtag = createStichtag(currentYear);
	}

	// Zähle alle berührten Geschäftsjahre
	let years = 0;
	let previousStichtag = createStichtag(currentYear - 1);

	// Iteriere durch alle möglichen Geschäftsjahre
	while (previousStichtag <= endDate) {
		// Prüfe ob das aktuelle Geschäftsjahr vom Projekt berührt wird
		// GJ läuft von previousStichtag (exklusiv) bis currentStichtag (inklusiv)
		const gjStart = new Date(previousStichtag.getTime() + 24 * 60 * 60 * 1000); // Tag nach previousStichtag
		const gjEnd = currentStichtag;

		// Wenn Projektende >= gjStart ODER Projektstart <= gjEnd
		// dann überlappt das Projekt mit diesem Geschäftsjahr
		if (endDate >= gjStart || startDate <= gjEnd) {
			// Prüfe ob es wirklich eine Überlappung gibt
			if (!(endDate < gjStart || startDate > gjEnd)) {
				years++;
			}
		}

		// Gehe zum nächsten Geschäftsjahr
		previousStichtag = currentStichtag;
		currentYear++;
		currentStichtag = createStichtag(currentYear);
	}

	// Mindestens 1 Jahr
	if (years < 1) {
		years = 1;
	}

	result.push({
		path: P.Allgemein_Projektdauerin_Jahren.path,
		value: years,
	});

	return result;
};

export const ersteVerbundPartnerAnlegen = (_application: any) => {
	let result: any[] = [];
	// const allVerbundPartner = get(application, P.Verbundpartner.path, []);
	// const allAssoziiertePartner = get(application, P.Assoziierte_Partner.path, []);

	// if (get(application, P.Allgemein_Vorhabensart.path) === VORHABENS_ART.Verbundvorhaben) {
	// 	result.push(
	// 		{
	// 			path: addIndexesToPath(P.Verbundpartner.path, [`${allVerbundPartner.length}`], ['Verbundpartner']),
	// 			value: { Rechtsverbindlicher_Name_Der_Organisation: '', Verbundpartner_Ansprechpartnerin: [{ Vorname: '' }] },
	// 		},
	// 		{
	// 			path: addIndexesToPath(P.Assoziierte_Partner.path, [`${allAssoziiertePartner.length}`], ['Assoziierte_Partner']),
	// 			value: { Rechtsverbindlicher_Name_Der_Organisation: '', Assoziierte_Partner_Ansprechpartnerin: [{ Vorname: '' }] },
	// 		}
	// 	);
	// }

	// if (get(application, P.Allgemein_Vorhabensart.path) === VORHABENS_ART.Einzelvorhaben) {
	// 	result.push(
	// 		{
	// 			path: P.Verbundpartner.path,
	// 			value: [],
	// 		},
	// 		{
	// 			path: P.Assoziierte_Partner.path,
	// 			value: [],
	// 		}
	// 	);
	// }

	return result;
};

export const calculateGesamtSumme = (application: any) => {
	let result: any = [];
	const allKostenPosition = get(application, P.Foerderantrag_Kostenpositions.path, []);

	let ProjektAusgabenGesamt = 0;
	let ProjektEinnahmenGesamt = 0;
	let BeantragteZuwendungGesamt = 0;
	let FoerderquoteGesamt = 0;

	for (let i = 0; i < allKostenPosition.length; i++) {
		const eachKostenPosition = allKostenPosition[i];

		if (get(eachKostenPosition, KP_P.Allgemein_Kostenposition.path, '') === 'Ausgabe') {
			const ausgabe = parseFloat(get(eachKostenPosition, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
			ProjektAusgabenGesamt += isFinite(ausgabe) ? ausgabe : 0;
		}
		if (get(eachKostenPosition, KP_P.Allgemein_Kostenposition.path, '') === 'Einnahme') {
			const einnahme = parseFloat(get(eachKostenPosition, KP_P.Allgemein_Geplante_Gesamtsumme.path, '0.0'));
			ProjektEinnahmenGesamt += isFinite(einnahme) ? einnahme : 0;
		}
	}

	BeantragteZuwendungGesamt = ProjektAusgabenGesamt - ProjektEinnahmenGesamt;
	FoerderquoteGesamt =
		ProjektAusgabenGesamt > 0 && isFinite(BeantragteZuwendungGesamt) && isFinite(ProjektAusgabenGesamt) ?
			(BeantragteZuwendungGesamt / ProjektAusgabenGesamt) * 100
		:	0;

	result.push(
		{
			path: P.Allgemein_Geplante_Projektausgaben.path,
			value: !isNaN(ProjektAusgabenGesamt) && isFinite(ProjektAusgabenGesamt) ? ProjektAusgabenGesamt.toFixed(2) : 0,
		},
		{
			path: P.Allgemein_Eingebrachte_Eigen_Und_Drittmittel.path,
			value: !isNaN(ProjektEinnahmenGesamt) && isFinite(ProjektEinnahmenGesamt) ? ProjektEinnahmenGesamt.toFixed(2) : 0,
		},
		{
			path: P.Allgemein_Beantragte_Zuwendung.path,
			value: !isNaN(BeantragteZuwendungGesamt) && isFinite(BeantragteZuwendungGesamt) ? BeantragteZuwendungGesamt.toFixed(2) : 0,
		},
		{
			path: P.Bewilligung_Foerderquote_Gesamt.path,
			value: !isNaN(FoerderquoteGesamt) && isFinite(FoerderquoteGesamt) ? FoerderquoteGesamt.toFixed(2) : 0,
		},
		{
			path: P.Allgemein_Foerderquote_Gesamt.path,
			value: !isNaN(FoerderquoteGesamt) && isFinite(FoerderquoteGesamt) ? FoerderquoteGesamt.toFixed(2) : 0,
		}
	);

	return result;
};

/*
 ***********************************************************************************************************
 * *********************************** HELPER FUNCTIONS ****************************************************
 * *********************************************************************************************************
 */

const getMonthIndex = (monthName: string): number => {
	return MONAT_LISTE.findIndex((m) => m.Monat === monthName);
};

// export const calculateProjektDauer_OLD = (application: any, vonTag: number, vonMonat: string, bisTag: number, bisMonat: string): FormulasResultType[] => {
// 	const result: FormulasResultType[] = [];
// 	const projektStartVon = get(application, P.Allgemein_Geplante_Projektlaufzeit_von.path, '');
// 	const projektStartBis = get(application, P.Allgemein_Geplante_Projektlaufzeit_bis.path, '');

// 	if (projektStartVon && projektStartBis) {
// 		const startDate = new Date(projektStartVon);
// 		const endDate = new Date(projektStartBis);

// 		const vonMonthIndex = getMonthIndex(vonMonat);
// 		const bisMonthIndex = getMonthIndex(bisMonat);

// 		// Define the start and end of the first full year period
// 		const firstYearStart = new Date(startDate.getFullYear(), vonMonthIndex, vonTag);
// 		const firstYearEnd = new Date(firstYearStart.getFullYear() + 1, bisMonthIndex, bisTag);

// 		let years = 0;

// 		// Check if we need to count the initial partial year
// 		if (startDate < firstYearStart) {
// 			years++;
// 		}

// 		// Calculate the number of full years between the start and end dates
// 		if (startDate <= firstYearEnd && endDate >= firstYearStart) {
// 			years += Math.floor((endDate.getTime() - firstYearStart.getTime()) / (365.25 * 24 * 60 * 60 * 1000)) + 1;
// 		}

// 		// Handle cases where the end date is after the `bisTag` and `bisMonat` but not enough to count a full additional year
// 		const normalizedEndDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
// 		const normalizedFirstYearEnd = new Date(firstYearEnd.getFullYear(), firstYearEnd.getMonth(), firstYearEnd.getDate());

// 		// Add an extra year only if the endDate is beyond the firstYearEnd and represents a new full year cycle
// 		if (normalizedEndDate > normalizedFirstYearEnd) {
// 			// Check if the endDate is within the buffer period that counts as a new year
// 			const nextCycleStart = new Date(firstYearEnd.getFullYear() + years, vonMonthIndex, vonTag);
// 			if (normalizedEndDate >= nextCycleStart) {
// 				years++;
// 			}
// 		}

// 		result.push({
// 			path: P.Allgemein_Projektdauerin_Jahren.path,
// 			value: years,
// 		});
// 	}
// 	return result;
// };
